import './RouteFallback.css';

import { IonContent, IonSpinner } from '@ionic/react';
import React from 'react';

const RouteFallback: React.FC = () => {
  return (
    <IonContent>
      <div className="route-fallback">
        <div className="route-fallback__card">
          <div className="route-fallback__title">Loading…</div>
          <IonSpinner className="route-fallback__spinner" name="crescent" />
        </div>
      </div>
    </IonContent>
  );
};

export default RouteFallback;

